import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import LayoutAction from '../../../../../modules/actions/LayoutAction';

const ThirdLevelComponent = (props) => {
  const {
    selectedMenu: initialSelectedMenu,
    menuHierarchy,
    translationCache: initialTranslationCache,
    layoutAction,
    navigate
  } = props;

  const [selectedMenu, setSelectedMenu] = useState(initialSelectedMenu);
  const [thirdLevelMenuItems, setThirdLevelMenuItems] = useState([]);
  const [currentMenu, setCurrentMenu] = useState('');
  const [translationCache, setTranslationCache] = useState(initialTranslationCache);

  useEffect(() => {
    if (initialSelectedMenu !== selectedMenu) {
      setSelectedMenu(initialSelectedMenu);
    }
  }, [initialSelectedMenu, selectedMenu]);

  useEffect(() => {
    if (initialTranslationCache !== translationCache) {
      setTranslationCache(initialTranslationCache);
    }
  }, [initialTranslationCache, translationCache]);

  useEffect(() => {
    if (selectedMenu && selectedMenu.length > 0 && menuHierarchy) {
      const thirdLevelMenuData =
        menuHierarchy[selectedMenu[0]]?.children?.[selectedMenu[1]]?.children || [];

      const convertedMenuItems = thirdLevelMenuConversion(thirdLevelMenuData);
      setThirdLevelMenuItems(convertedMenuItems);

      if (selectedMenu.length === 3) {
        setCurrentMenu(selectedMenu[2]);
      }
    }
  }, [selectedMenu, menuHierarchy, translationCache]);

  const thirdLevelMenuConversion = (menu) => {
    if (!menu) return [];

    return Object.keys(menu).map((pMenu) => {
      const menuItem = menu[pMenu];
      let children = [];
      if (menuItem?.children) {
        children = thirdLevelMenuConversion(menuItem.children);
      }
      return {
        key: menuItem?.key || "",
        label: menuItem?.name ? translation(menuItem.name) : "",
        path: menuItem?.path || "",
        ...(children && Array.isArray(children) && children.length > 0 ? { children } : {})
      };
    });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const findObjectByKey = (obj, key, value) => {
    if (Array.isArray(obj)) {
      for (let i = 0; i < obj.length; i++) {
        const result = findObjectByKey(obj[i], key, value);
        if (result) {
          return result;
        }
      }
    } else if (typeof obj === 'object' && obj !== null) {
      if (obj[key] === value) {
        return obj;
      }
      for (const k in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
          const result = findObjectByKey(obj[k], key, value);
          if (result) {
            return result;
          }
        }
      }
    }
    return null;
  };

  return (
    thirdLevelMenuItems ? (
      <div style={{ marginTop: '64px' }}>
        <Menu
          theme="light"
          mode="horizontal"
          selectedKeys={[currentMenu]}
          items={thirdLevelMenuItems}
          onClick={(e) => {
            const newMenu = [selectedMenu[0], selectedMenu[1], e.key];
            const selectedObj = findObjectByKey(thirdLevelMenuItems, 'key', e.key);
            layoutAction.setMenuSelection(newMenu);
            navigate(selectedObj.path);
          }}
        />
      </div>
    ) : null
  );
};

const mapDispatchToProps = (dispatch) => ({
  layoutAction: bindActionCreators(LayoutAction, dispatch)
});

const mapStateToProps = (state) => ({
  selectedMenu: state.LayoutReducer.menuSelected,
  menuHierarchy: state.LayoutReducer.menuHierarchy,
  translationCache: state.TranslationReducer.translationCache,
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    let router = { location, navigate, params };
    return <Component {...props} {...router} />;
  }
  return ComponentWithRouterProp;
}

const ConnectedThirdLevelComponent = connect(mapStateToProps, mapDispatchToProps)(ThirdLevelComponent);

export default withRouter(ConnectedThirdLevelComponent);
